import { init, RematchDispatch, RematchRootState } from "@rematch/core"
import { dialogsModel } from "./models/dialogsModel"
import { createLogger } from "redux-logger"

const reduxLogger = createLogger({
    collapsed: true,
    diff: true,
})

// Init
export const initStore = init({
    redux: {
        devtoolOptions: {
            disabled: true, // Disable redux-devtools
        },
        middlewares: process.env.NODE_ENV === "development" ? [reduxLogger] : [], // Use redux-logger instead
    },
    models: {
        dialogsModel: dialogsModel,
    },
})

// Typings
export interface RootModel {
    dialogsModel: typeof dialogsModel
}

export type Store = typeof store
export type Dispatch = RematchDispatch<RootModel>
export type StateObject = RematchRootState<RootModel>
